import { generateRecentTimestamp } from "../utils/timestamp";

const driverInfo = {
  driverInfo: {
    drivingLicense: "PDRV#123456",
    regionDepot: "Abu Dhabi",
    totalTrips: "1458",
    drivingScore: "75",
    passengersCarried: "25896",
    totalHoursDriven: "150",
    totalViolations: "50",
    totalMiles: "1500",
    trips: [
      {
        tripNo: "1",
        tripStatus: "In Progress",
        occupancy: "20/40",
        speed: "10 mph",
        workStatus: "On Trip",
        distanceCovered: "20 Miles",
        distance: "150 Miles",
        busId: "Bus#123",
        violations: "05",
        drivingScore: "75",
        harshAccelaration: "0",
        corner: "0",
        overspeeding: "10",
        harshBraking: "0",
        idleHours: "0",
        fatigue: "Very Active",
        routeDetails: {
          route: "Route#123",
          routeStops: {
            totalStops: "5",
            stopsCovered: "3",
            stoppages: [
              {
                name: "Source",
                observation: "15 Min Delay",
                area: "Al Maryah Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4905,
                  lng: 54.3668,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Current Location",
                observation: "Over Speeding",
                area: "Al Reem Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.5229,
                  lng: 54.4031,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 1",
                observation: "Next Stop",
                area: "Yas Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4958,
                  lng: 54.6061,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 2",
                observation: "Estimated Arrival",
                area: "Mussafah, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4096,
                  lng: 54.4356,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 3",
                observation: "Estimated Arrival",
                area: "Mohammed Bin Zayed City, Abu Dhabi",
                coOrdinates: {
                  lat: 24.5457,
                  lng: 54.6100,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Destination",
                observation: "Estimated Arrival",
                area: "Abu Dhabi Corniche",
                coOrdinates: {
                  lat: 24.4861,
                  lng: 54.3571,
                },
                timeStamp: generateRecentTimestamp(),
              },
            ],
          },
        },
      },
      {
        tripNo: "2",
        tripStatus: "Completed",
        occupancy: "35/40",
        speed: "0 mph",
        workStatus: "Finished",
        distanceCovered: "150 Miles",
        distance: "150 Miles",
        busId: "Bus#123",
        violations: "02",
        drivingScore: "85",
        harshAccelaration: "1",
        corner: "0",
        overspeeding: "1",
        harshBraking: "0",
        idleHours: "0.5",
        fatigue: "Active",
        routeDetails: {
          route: "Route#124",
          routeStops: {
            totalStops: "5",
            stopsCovered: "5",
            stoppages: [
              {
                name: "Source",
                observation: "On Time",
                area: "Yas Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4958,
                  lng: 54.6061,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 1",
                observation: "Arrived",
                area: "Mohammed Bin Zayed City, Abu Dhabi",
                coOrdinates: {
                  lat: 24.5457,
                  lng: 54.6100,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 2",
                observation: "Arrived",
                area: "Mussafah, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4096,
                  lng: 54.4356,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 3",
                observation: "Arrived",
                area: "Al Ain, Abu Dhabi",
                coOrdinates: {
                  lat: 24.2075,
                  lng: 55.7447,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Destination",
                observation: "Arrived",
                area: "Al Maryah Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4905,
                  lng: 54.3668,
                },
                timeStamp: generateRecentTimestamp(),
              },
            ],
          },
        },
      },
      {
        tripNo: "3",
        tripStatus: "Completed",
        occupancy: "40/40",
        speed: "0 mph",
        workStatus: "Finished",
        distanceCovered: "150 Miles",
        distance: "150 Miles",
        busId: "Bus#123",
        violations: "0",
        drivingScore: "95",
        harshAccelaration: "0",
        corner: "0",
        overspeeding: "0",
        harshBraking: "0",
        idleHours: "0.2",
        fatigue: "Very Active",
        routeDetails: {
          route: "Route#125",
          routeStops: {
            totalStops: "5",
            stopsCovered: "5",
            stoppages: [
              {
                name: "Source",
                observation: "On Time",
                area: "Al Maryah Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4905,
                  lng: 54.3668,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 1",
                observation: "Arrived",
                area: "Al Reem Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.5229,
                  lng: 54.4031,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 2",
                observation: "Arrived",
                area: "Downtown Abu Dhabi",
                coOrdinates: {
                  lat: 24.4539,
                  lng: 54.3773,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 3",
                observation: "Arrived",
                area: "Capital Gate, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4186,
                  lng: 54.4347,
                },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Destination",
                observation: "Arrived",
                area: "Yas Island, Abu Dhabi",
                coOrdinates: {
                  lat: 24.4958,
                  lng: 54.6061,
                },
                timeStamp: generateRecentTimestamp(),
              },
            ],
          },
        },
      },
    ],
    pastViolations: [
      {
        violationType: "Overspeeding",
        busNo: "123",
        route: "Route#123",
        timeStamp: generateRecentTimestamp(),
      },
      {
        violationType: "Harsh Acceleration",
        busNo: "123",
        route: "Route#124",
        timeStamp: generateRecentTimestamp(),
      },
      {
        violationType: "Overspeeding",
        busNo: "123",
        route: "Route#124",
        timeStamp: generateRecentTimestamp(),
      },
      {
        violationType: "Overspeeding",
        busNo: "123",
        route: "Route#120",
        timeStamp: generateRecentTimestamp(),
      },
      {
        violationType: "Harsh Braking",
        busNo: "123",
        route: "Route#119",
        timeStamp: generateRecentTimestamp(),
      },
    ],
  },
};
export default driverInfo;
